import { FormAttachment } from '@/components/Attachment/schema'
import { Attachment } from '@/utils/fetchers/attachment'
import { useWatch } from 'react-hook-form'

export default function useAttachments() {
	const attachmentIds = useWatch<{ attachment: FormAttachment }, 'attachment.ids'>({
		name: 'attachment.ids',
	})
	const attachmentMap = useWatch<{ attachment: FormAttachment }, 'attachment.map'>({
		name: 'attachment.map',
	})

	return attachmentIds.map((id) => attachmentMap[id]).filter(Boolean) as Attachment[]
}
